// Class
import { SmartTagBase } from './smartTagBase';
// Model
import { SmartTagModel } from './smartTag.model';

export class SmartTagFenceModel extends SmartTagModel {
	fenceType?: any[];

	constructor() {
		super();

		this.fenceType = [];
	}
}

export class SmartTagFence extends SmartTagBase {

	/**
	 * Renderer
	 * @param data SmartTagUpdateModel
	 */
	public render(data: SmartTagFenceModel, version?: string): string {
		this.getData(data);

		return this.getOutputData(version || 'v1');
	}

	private getData(data: SmartTagFenceModel): void{
		const title = data.title || data.subCategory || '';
		const fenceTypes = data.fenceType || [];
		const description = data.description?.trim() || '';

		if (title !== '') {
			this.title = `<span title="${title}">Type: ${title}</span>`;
		}
		if (fenceTypes && fenceTypes.length > 0) {
			this.addText(`<span title="Update Type:">Fence Type:</span>`);
			fenceTypes.forEach((fenceType: any) => {
				this.addText(`<span title="${fenceType.typeName}">&nbsp;&nbsp;&nbsp;&nbsp;${fenceType.typeName}</span>`);
			});
		}
		if (description !== '') {
			this.addText(`<span title="${description}">Description: ${description}</span>`);
		}
	}
}
